export default {
  state: () => ({})
}
